import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { hierarchyFilterOptionsQueryOptions } from '@/features/leaveApplications/api/leaveApplications.api';
import { HIERARCHY_FILTER_TYPE } from '@/features/leaveApplications/constants/leaveApplication.constants';
import { useAuthStore } from '@/store/auth.store';

export function useAmFilterOptions(isEnabled: boolean) {
  const { data: amOptions, isError } = useQuery({
    ...hierarchyFilterOptionsQueryOptions(HIERARCHY_FILTER_TYPE.AM),
    enabled: isEnabled,
  });

  const currentUserId = useAuthStore((state) => state.user?.id);
  const amOptionsWithoutCurrentUser = useMemo(
    () => amOptions?.filter((am) => am.id !== currentUserId),
    [amOptions, currentUserId],
  );

  return {
    amOptions: amOptionsWithoutCurrentUser,
    hasAmOptionsError: isError,
  };
}
